import { render, staticRenderFns } from "./adminServ.vue?vue&type=template&id=4c23a3f0&scoped=true"
import script from "./adminServ.vue?vue&type=script&lang=js"
export * from "./adminServ.vue?vue&type=script&lang=js"
import style0 from "./adminServ.vue?vue&type=style&index=0&id=4c23a3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c23a3f0",
  null
  
)

export default component.exports